/** Poppins Regular 14px / 120% — Figma sidebar nav items (Grey/950 · dark Grey/300) */
export const sidebarNavItemLabelClass =
  'font-sans text-sm font-normal leading-heading tracking-normal text-grey-950 dark:text-grey-300';

/** Selected nav/section label — Figma Grey/50 #F6F6F6 */
export const sidebarNavItemLabelActiveClass = 'dark:text-grey-50';
